import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import HairAnalysis from './pages/services/analysis';
import CustomHairSystems from './pages/services/custom';
import ScalpTreatments from './pages/services/treatments';
import Maintenance from './pages/services/maintenance';

function App() {
  return (
    <Router basename="/">
      <div className="App">
        <Header />
        <main className="pt-28 lg:pt-32">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/services/analysis" element={<HairAnalysis />} />
            <Route path="/services/custom" element={<CustomHairSystems />} />
            <Route path="/services/treatments" element={<ScalpTreatments />} />
            <Route path="/services/maintenance" element={<Maintenance />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;




